import { useAtom } from 'jotai'

import ArrowIcon from 'assets/icons/arrow.svg'
import BbThumbnail from 'assets/images/nma-no-image.jpg'
import { ModalAtom } from 'atoms/modals.atom'
import { AwardsFile } from 'types/AwardsFile'

import { WinnerTag } from './WinnerTag'

export interface AwardCardProps {
  award: AwardsFile
}

export const AwardsCard = (props: AwardCardProps) => {
  const [, setModalOpen] = useAtom(ModalAtom)
  const handleOnClick = () => {
    if (award.year === 2023) {
      window.open(award.url, '_blank')
      return
    }
    setModalOpen({ isOpen: true, award })
  }
  const { award } = props
  const ouArray = award?.ou?.split(',')
  return (
    <div
      onClick={handleOnClick}
      className="w-[568px] h-[218px] rounded-2xl relative flex items-center justify-center group hover:shadow-[0px_14px_24px_0px_#0000000F] cursor-pointer"
    >
      {award.winner === 1 && (
        <div className="absolute top-6 left-6 z-30">
          <WinnerTag />
        </div>
      )}
      <div className="z-10 absolute top-0 left-0 w-full h-full rounded-2xl bg-[#D7D7D7] transition-opacity "></div>
      {/*<div className="z-10 absolute top-0 left-0 w-full h-full rounded-2xl opacity-0 transition-opacity group-hover:opacity-100 bg-gradient-to-b from-[#FFFFFF] to-[#6E6E6E]"></div>*/}
      <div className="z-20 w-[564px] h-[214px] p-4 bg-white rounded-[14px] flex">
        <div className="relative">
          <img
            src={award.thumbnail ?? BbThumbnail}
            alt={award.name}
            className="w-[280px] h-full rounded-lg object-cover"
          />
          <img src={award.brandLogoUrl} alt="" className="absolute right-0 top-0 w-14" />
        </div>
        <div className="flex flex-col px-4 w-full max-w-[246px] h-full whitespace-normal ">
          <p className="text-[12px] text-[#4C4C4C] font-TCCC font-bold capitalize">{award.tcccCategory}</p>
          <p className="text-[18px] font-semibold text-clip max-h-[160px] mt-1 mb-2 line-clamp-3">{award.name}</p>
          <p className="text-[14px] text-[#4C4C4C] font-TCCC font-semibold capitalize">
            {ouArray.map(
              (ou, index) => `${index < 4 ? ou : ''}${index < 3 && index + 1 !== ouArray.length ? ', ' : ''}`,
            )}
            {ouArray.length > 4 && `, +${ouArray.length - 4}`}
          </p>
          <div className="absolute flex bottom-4 right-4 group justify-between overflow-hidden">
            <p className="mr-2 translate-x-32 origin-right font-bold overflow-hidden transition-all duration-300 whitespace-nowrap group-hover:translate-x-0 ">
              View {award.year !== 2023 ? 'entry' : 'file'}
            </p>
            <img src={ArrowIcon} alt="" />
          </div>
        </div>
      </div>
    </div>
  )
}
